import React from "react";
import { makeStyles } from "@material-ui/core";
import "./Service.css";

// Components
import PhysicalInfrastructure from "./PhysicalInfrastructure";
import Projects from "./PhysicalProjects";
import Solution from "./Solution";
import Consult from "./Consult";

const useStyles = makeStyles((theme) => ({
	service: {},
}));

const Service = () => {
	const classes = useStyles();
	return (
		<div className={classes.service}>
			<PhysicalInfrastructure />
			<Projects />
			<Solution />
			<Consult color={"physical"} />
		</div>
	);
};

export default Service;
